(() => {
  const key = "k8s-dashboard.theme.v1";
  const maxBytes = 128;
  const allowed = ["system", "light", "dark"];
  let theme = "system";
  try {
    const raw = window.localStorage.getItem(key);
    if (raw && raw.length <= maxBytes && new TextEncoder().encode(raw).byteLength <= maxBytes) {
      const value = JSON.parse(raw);
      const keys = value && typeof value === "object" && !Array.isArray(value) &&
        Object.getPrototypeOf(value) === Object.prototype ? Object.keys(value).sort() : [];
      if (keys.length === 2 && keys[0] === "theme" && keys[1] === "version" &&
          value.version === 1 && allowed.includes(value.theme)) {
        theme = value.theme;
      } else {
        window.localStorage.removeItem(key);
      }
    } else if (raw !== null) {
      window.localStorage.removeItem(key);
    }
  } catch {
    theme = "system";
  }
  if (theme === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", theme);
})();
